export default __webpack_public_path__ + "static/media/ca-ontario-kings.b40d30c4.svg";